module.exports = __webpack_public_path__ + "static/energy_8-0217eafc4096a98c5a9a9b3b88259b42.jpg";